import type { TaskWithOccurrences } from "@dashboard/api/task";
import { ProgressFraction, TasksProgress } from "../ProgressBar";
import TaskItem from "./Task";

export function Group({ tasks, title }: { tasks: TaskWithOccurrences[]; title: string }) {
    return (
        <section className="flex flex-col gap-3">
            <div className="flex items-center justify-between gap-3">
                <h2 className="text-sm font-medium text-compendia-foreground overflow-hidden text-ellipsis">
                    {title}
                </h2>
                <TasksProgress tasks={tasks}>
                    <ProgressFraction />
                </TasksProgress>
            </div>
            <div className="flex flex-col gap-2">
                {tasks.map((task) => (
                    <TaskItem key={task.id} task={task} />
                ))}
            </div>
        </section>
    );
}
